import { ChatIcon } from "@/constant/imagePath";
import IconButton from "..";

const ChatButton = ({
  icon = ChatIcon,
  borderColor = "#214DA0",
  fromColor = "#3F86F7",
  toColor = "#214DA0",
  buttonStyle = { padding: "4px 3px 2px 3px" },
  onClick = null,
  tooltipText = "Chat",
  text = null,
  ...props
}) => {
  return (
    <IconButton
      text={text}
      icon={icon}
      borderColor={borderColor}
      fromColor={fromColor}
      toColor={toColor}
      buttonStyle={buttonStyle}
      onClick={onClick}
      tooltipText={tooltipText}
      {...props}
    />
  );
};

export default ChatButton;
